import { useContext } from "react";
import { DisplayContext } from "../";

/**
 * @typedef {import('../').WidgetDisplayContext} WidgetDisplayContext
 */

/**
 * @returns {WidgetDisplayContext} the display function
 */
export const useDisplayContext = () => {
  return useContext(DisplayContext);
};
